import React,{Component} from 'react';

import PoistonVarmistus from './PoistonVarmistus';
import PostingListItem from './PostingListItem';
import NewGroup from './NewGroup';
import packageJson   from '../package.json';
class PostingListView extends Component{

  constructor(props){
    super(props);
    this.showNewGroupDialogs = this.showNewGroupDialogs.bind(this);
    this.hideNewGroupDialogs = this.hideNewGroupDialogs.bind(this);
    this.hideDeleteConfirmation = this.hideDeleteConfirmation.bind(this);
    this.showDeleteConfirmation = this.showDeleteConfirmation.bind(this);
    this.state = {showNewGroupDialog: false, postings: this.props.postings };
    this.deletePosting = this.deletePosting.bind(this);
  }


  showNewGroupDialogs(){
    this.setState({showNewGroupDialog: true});
  }
  hideNewGroupDialogs(){
    this.setState({showNewGroupDialog: false});
  }
  hideDeleteConfirmation(){
    this.setState({naytaPoistonVarmistus: false})
  }

  deletePosting(){
    this.props.deletePosting(this.state.groupToBeDeleted);
    let updatedPostings = this.state.postings.filter(posting => posting._id !== this.state.groupToBeDeleted._id);
    console.log("updatedPostings");
    console.log(updatedPostings);
    this.setState({ postings: updatedPostings});
    this.setState({naytaPoistonVarmistus: false})
   
  }
  componentDidUpdate(prevProps) {
    if (prevProps.postings !== this.props.postings) {
      this.setState({ postings: this.props.postings });
    }
  }

  showDeleteConfirmation(group){
    this.setState({groupToBeDeleted: group});
    this.setState({naytaPoistonVarmistus: true})
  }



  render(){
    const postings = this.state.postings != undefined ? this.props.postings.map( (i,index) => {
      return (  <PostingListItem posting={i}  key={index} savePosting={this.props.savePosting} deletePosting={this.showDeleteConfirmation}/> )
    }): null;
      return (
        <div style={{height:"100%", width:"100%"}}>
          
           <div className="workersListHeader alert alert-info"><span className="version">ver.{packageJson.version}</span>Komennusmiehet</div>
        <div style={{height:"100%", width:"100%" , padding:"20px" , overflow: "auto", paddingBottom:"150pt"}}>
        <PoistonVarmistus handlePoisto={this.deletePosting} handlePeruutaPoisto={this.hideDeleteConfirmation} naytaPoistonVarmistus={this.state.naytaPoistonVarmistus}/>
        <NewGroup saveGroup={this.props.savePosting} showNewDialog={this.state.showNewGroupDialog} hideNewGroupDialogs={this.hideNewGroupDialogs}/>
        <table style={{width:100 + "%", padding: "20px"}}>
        {postings != null  && postings.length  > 0 ?(<tr><th >Ryhmännimi</th><th >Vastuuhenkilö</th><th>Vast.hlö puh</th><th  >Työaika</th><th >Saapumispäivä</th><th >Lähtöpäivä</th><th  >Majoitus</th><th  >&nbsp;</th></tr>):""}
        {postings}
        </table>
        <button className="btnThirdButton" onClick={this.showNewGroupDialogs}  >
        Lisää ryhmä
    </button>
    <button className="btnClose" onClick={this.props.changeToEmployeesView}  >
        Palaa
    </button>
    </div>
    </div>
    )


  }
}
export default PostingListView;
